<script lang="ts">
	// Main tab content for SNGW-BT01
</script>

<div class="main-content">
	<h3>Main Content for SNGW-BT01</h3>
	<p>This is the main tab content for the SNGW-BT01 device.</p>
	<!-- Add your specific main content here -->
</div>

<style>
	.main-content {
		padding: 1rem;
	}
</style>
